<template>
    <div style="height:450px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-6 text-left">
                <h4 class="card-title pb-2 pt-2 mb-0">Report Fungsi Magang</h4>
            </div>
            <div class="col-6">
                <month-picker-input placeholder="Bulan, Tahun" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="donut" height="300" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div class="row no-gutters text-left">
            <div class="col-12">
                <CButton class="mr-4" @click="getDownload()" color="success" variant="outline">Export Excel</CButton>
            </div>
        </div>
    </div>
</template>

<script>
import {DataApi} from "../../service/DataApi";
import { MonthPickerInput } from 'vue-month-picker'


const xlsx = require('json-as-xlsx')
export default {    
    components: {
        MonthPickerInput
    },
    data() {
        return {
            lists: [],
            jumlahs: [],
            downloadIcon: require('../../assets/menu/icon_download_excel.svg'),
            status: false,
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),
            series: [],
            chartOptions: {
                chart: {
                    id: 'diagram',
                    width: 300,
                    type: 'donut',
                    dropShadow: {
                        enabled: true,
                        color: '#111',
                        top: -1,
                        left: 3,
                        blur: 3,
                        opacity: 0.2
                    }
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                pie: {
                    donut: {
                    labels: {
                        show: true,
                        total: {
                            showAlways: true,
                            show: true,
                            formatter: function (w) {
                                let vals = w.globals.seriesTotals
                                var i = 0
                                let totals = 0
                                for(i=0;i<vals.length;i++) {
                                    totals += vals[i]
                                }
                                let val = totals.toString()
                                let leng = val.length
                                let sisa 	= leng % 3
                                let rupiah 	= val.substr(0, sisa)
                                let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                        name: {
                            show: true,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            formatter: function (val) {
                                let value = val.toString()
                                let leng = value.length
                                let sisa 	= leng % 3
                                let rupiah 	= value.substr(0, sisa)
                                let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                    }
                    }
                }
                },
                labels: [],
                dataLabels: {
                    dropShadow: {
                        blur: 3,
                        opacity: 0.8
                    }
                },
                states: {
                    hover: {
                        filter: 'none'
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        }
    },
    watch: {
        date() {
            this.status = false
            this.getData()
        }
    },
    methods: {
        getData() {
            this.$emit('flagFungsi', false)
            let payload = {
                bulan: this.date.monthIndex,
                tahun: this.date.year
            }
            DataApi.post("/magang/dashboard/dua", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    let list = temp.listKeterangan
                    let jumlah = temp.listJumlah
                    this.lists = list
                    this.jumlahs = jumlah
                    var i = 0
                    var j = 0
                    for(i=0;i<list.length;i++) {
                        this.chartOptions.labels[i] = list[i]
                    }
                    for(j=0;j<list.length;j++) {
                        this.series[j] = jumlah[j]
                    }
                    this.status = true
                    this.$emit('flagFungsi', true)
                }
            })
        },
        getDownload() {
            this.$emit('flagFungsi', false)
            var k = 0
            let download = []
            for(k=0;k<this.lists.length;k++) {
                let onPush = {
                    nama: this.lists[k],
                    total: this.jumlahs[k]
                }
                download.push(onPush)
            }
            let fileName = 'Jumlah Peserta Berdasarkan Fungsi'
            let data = [
                {
                    sheet: 'Fungsi',
                    columns: [
                        { label: 'Nama Fungsi', value: 'nama'  },
                        { label: 'Total', value: 'total' },
                    ],
                    content: download
                }
            ]
            let settings = {
                fileName: fileName
            }
            xlsx(data, settings)
            this.$emit('flagFungsi', true)
        },
        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
            this.getData()
        },
        showDate(date) {
            this.date = date
        }
    },
    mounted() {
        this.setDate()
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
    margin-left: -64px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
</style>